import React, { useEffect, useState } from "react"
import { Container, Card, CardBody, Row, Col } from "reactstrap"
import classNames from "classnames"
import moment from "moment"
import Swal from "sweetalert2"
import ReactSelect from "react-select"
import Calendar from "react-calendar"
import "../../assets/css/Calender/Devcalender.css"
import { colourStyles, workingtimeSlots } from "utils/common-options"
import { parseDateTimeSlot } from "utils/common-helpers"
import { FetchNodePostData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import configure from "configure"
import axios from "axios"
import { useParams } from "react-router-dom"

const StepNavigationStep = ({ step, currentStep, onStepChange }) => {
  const classes = classNames({
    active: step.id === currentStep,
    complete: currentStep > step.id,
  })

  return (
    <li
      className={classes}
      onClick={() => {
        if (currentStep >= step.id) {
          onStepChange(step.id)
        }
      }}
    >
      <div className="step">
        <i className={step.icon_class}></i>
      </div>
      <div className="caption hidden-xs hidden-sm">
        <span className="fs-5">{step.title}</span>
      </div>
    </li>
  )
}

const StepNavigation = ({ steps, currentStep, onStepChange }) => {
  return (
    <ol className="step-indicator">
      {steps.map(step => (
        <StepNavigationStep
          key={step.id}
          step={step}
          currentStep={currentStep}
          onStepChange={onStepChange}
        />
      ))}
    </ol>
  )
}

const CalenderIndex3 = () => {
  const [currentStep, setCurrentStep] = useState(1)

  const { id } = useParams()

  const extractedId = id?.match(/\d+/)?.[0] || null
  console.log("Extracted ID:", extractedId)

  const [userId, setUserId] = useState(extractedId)

  // Step 1
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [selectedSlot, setSelectedSlot] = useState("")

  // Step 2
  const [meetingTitle, setMeetingTitle] = useState("")
  const [description, setDescription] = useState("")
  const [loading, setLoading] = useState(false)
  const [bookedSlots, setBookedSlots] = useState([])
  useEffect(() => {
    if (!selectedDate) return

    fetchBookedSlots()
  }, [selectedDate])

  const fetchBookedSlots = async () => {
    try {
      toggleLoading(true)
      const dateStr = moment(selectedDate).format("YYYY-MM-DD")

      const body = {
        user_id: userId,
        date: dateStr,
      }

      const response = await axios.post(
        `${configure.nodeApi}/freeTimeSlots`,
        body
      )

      if (response.data.success) {
        // Extract "timeslot" column into array
        const taken = response.data.data.map(item => item.timeslot)
        setBookedSlots(taken)
      }
    } catch (error) {
      console.error("Error fetching booked slots:", error)
    } finally {
      toggleLoading(false)
    }
  }

  // Time Slots

  const steps = [
    { id: 1, title: "Select Date & Time", icon_class: "bi bi-1-circle-fill" },
    { id: 2, title: "Meeting Details", icon_class: "bi bi-2-circle-fill" },
  ]

  const stepChanged = step => setCurrentStep(step)

  // Save & Next logic
  const onSaveNext = () => {
    if (currentStep === 1) {
      if (!selectedDate || !selectedSlot) {
        Swal.fire({
          icon: "warning",
          text: "Please choose date & time slot",
        })
        return
      }
      setCurrentStep(2)
    } else if (currentStep === 2) {
      handleAddMeeting()
      // handleSubmit() // ✔️ call final submit
    }
  }

  const toggleLoading = loading => {
    setLoading(loading)
  }
  const handleAddMeeting = async () => {
    console.log("clg: function called")

    try {
      toggleLoading(true)

      const dateStr = moment(selectedDate).format("YYYY-MM-DD")
      const dates = parseDateTimeSlot(dateStr, selectedSlot)

      const formEntries = {
        title: meetingTitle,
        location: 1,
        timezone: "Asia/Kolkata",
        imp: 0,
        user_id: 1,
        attendees: [userId],
        aemail: [],
        date: dateStr,
        startDate: dates.start,
        endDate: dates.end,
        timeslot: selectedSlot,
        meeting_with: 5,
        description: description,
        meeting_link: "",
        recurring: 0,
        recurring_days: [],
        introducer_included: 0,
      }

      console.log("BODY:", formEntries)

      const res = await axios.post(`${configure.nodeApi}/calender`, formEntries)

      if (res?.status) {
        Swal.fire({
          icon: "success",
          text: "Your meeting has been successfully booked.",
        }).then(() => {
          // RESET ALL FIELDS (like reload)
          setMeetingTitle("")
          setSelectedSlot("")
          setDescription("")
          setSelectedDate(new Date())

          // RESET WIZARD TO STEP 1
          setCurrentStep(1)
          window.location.reload()
        })
      }
    } catch (error) {
      console.error("Error creating meeting:", error)

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while booking the meeting!",
      })
    } finally {
      toggleLoading(false)
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Row>
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                {/* Header + Save Button */}
                <div className="d-flex justify-content-between align-items-center wizard">
                  <h5 className="mb-0 fw-bold text-purple">Book Meeting</h5>

                  <div>
                    <a
                      className="btn text-white btn-save btn-label border-radius"
                      onClick={onSaveNext}
                    >
                      <i className="fas fa-save label-icon"></i>
                      {currentStep === 1 ? "Save & Next" : "Submit"}
                    </a>
                  </div>
                </div>

                {/* Steps */}
                <div className="container-fluid mt-3">
                  <StepNavigation
                    steps={steps}
                    currentStep={currentStep}
                    onStepChange={stepChanged}
                  />
                </div>
              </CardBody>
            </Card>

            {/* Step 1 */}
            {currentStep === 1 && (
              <Card className="mt-6">
                <CardBody>
                  <Row>
                    {/* LEFT COLUMN — CALENDAR */}
                    <Col md={6}>
                      <div className="text-center">
                        <h5 className="mb-2 fw-bold text-uppercase">
                          Select Date
                        </h5>

                        <h2 className="selected-date-text text-purple">
                          {moment(selectedDate).format("ddd, MMM DD")}
                        </h2>

                        {/* Center calendar */}
                        <div className="d-flex justify-content-center mt-3">
                          <div className="col-md-8">
                            <Calendar
                              onChange={date => setSelectedDate(date)}
                              value={selectedDate}
                              minDate={new Date()}
                              className="react-calendar d-block mx-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* RIGHT COLUMN — TIME SLOTS */}
                    <Col md={6}>
                      <h4
                        className="fw-bold "
                        style={{ marginBottom: "30px" }}
                      >
                        Select a Time Slot
                      </h4>

                      <div
                        className="row g-3 "
                        style={{ paddingRight: "275px" }}
                      >
                        {workingtimeSlots.map(slot => {
                          const isBooked = bookedSlots.includes(slot.value)

                          return (
                            <div className="col-6" key={slot.id}>
                              <button
                                className={`
          btn time-slot-btn w-100
          ${selectedSlot === slot.value ? "selected-slot" : "unselected-slot"}
          ${isBooked ? "time-slot-booked" : ""}
        `}
                                disabled={isBooked}
                                onClick={() => {
                                  if (!isBooked) setSelectedSlot(slot.value)
                                }}
                              >
                                {slot.label}
                              </button>
                            </div>
                          )
                        })}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}

            {/* Step 2 */}
            {currentStep === 2 && (
              <Card className="mt-3">
                <CardBody>
                  <form
                    onSubmit={e => e.preventDefault()}
                    style={{ paddingLeft: "180px", paddingRight: "180px" }}
                  >
                    {/* FORM HEADER */}
                    <div className="d-flex justify-content-between mb-4">
                      <div className="d-flex align-items-center col-md-8">
                        <div className="btn-meeting p-2 px-3 border-radius">
                          <i className="bi bi-calendar2 fs-5"></i>
                        </div>
                        <div className="d-flex gap-2 align-items-center col-md-10">
                          <h4 className="mb-0 ps-2 col-md-4">New Meeting</h4>
                        </div>
                      </div>
                    </div>

                    {/* TITLE */}
                    <div className="row">
                      <div className="col-md-6">
                        <label>Title</label>
                        <div className="d-flex align-items-center mb-3">
                          <i className="bi bi-pencil-square position-absolute ps-3 fs-5 text-link"></i>
                          <input
                            type="text"
                            placeholder="Add Title"
                            className="form-control ps-5"
                            value={meetingTitle}
                            onChange={e => setMeetingTitle(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="d-flex align-items-center mb-3">
                          {/* DATE */}
                          <div className="w-50">
                            <label>
                              Date <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              required
                              className="form-control"
                              value={moment(selectedDate).format("YYYY-MM-DD")}
                              disabled
                            />
                          </div>

                          {/* TIME SLOT */}
                          <div className="w-50 ps-3">
                            <label>
                              Time Slots <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedSlot}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* DATE + TIMESLOT */}
                    <div className="row"></div>

                    {/* DESCRIPTION */}
                    <div className="mb-3">
                      <label>Description</label>
                      <textarea
                        className="w-100 form-control"
                        rows={5}
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                      ></textarea>
                    </div>

                    {/* SUBMIT BUTTON */}
                    {/* <div className="me-2 d-flex justify-content-end">
                      <button
                        className="btn-meeting btn px-4 py-2"
                        onClick={handleSubmit}
                      >
                        Create
                      </button>
                    </div> */}
                  </form>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  )
} 

export default CalenderIndex3
